import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Drawer, DrawerOverlay, Flex, mode, theme, useColorMode, useDisclosure, useMediaQuery } from '@abb/uikit';
import { services } from 'config/services';
import { useDependencies, useUserData } from 'hooks';
import React, { useEffect } from 'react';
import * as rdd from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import LogoIcon from 'shared-components/icons/LogoIcon';
import NotificationProvider from 'shared-components/Notification/NotificationProvider';
import { CampaignNextModal } from './components/CampaignNextModal';
import { ConditionalContainer } from './components/ConditionalContainer';
import { ErrorAlert } from './components/ErrorAlert';
import { FatcaAlert } from './components/FatcaAlert';
import { Header } from './components/Header';
import { Main } from './components/Main';
import { Responsive } from './components/responsive';
import { Sidebar } from './components/Sidebar';
import { Survey } from './components/Survey';
import { TradePlatformModal } from './components/TradePlatformModal';
import { VideoTutorial } from './components/VideoTutorial';
export const Layout = (param)=>{
    let { children } = param;
    const { colorMode } = useColorMode();
    const location = useLocation();
    const { httpClient, languageService } = useDependencies();
    const [isLargerThanMd] = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);
    const { isOpen, onClose, onToggle } = useDisclosure({
        defaultIsOpen: false
    });
    const { data, isLoading } = useUserData();
    const [userInfo, permissions, processClaims] = data ?? [];
    const hasSentDeviceInfo = async ()=>{
        try {
            const pushToken = localStorage.getItem('pushToken');
            const deviceInfo = {
                app: 'CORPORATE_IB',
                fcmToken: pushToken,
                browserName: rdd.browserName,
                browserVersion: rdd.browserVersion,
                deviceOs: rdd.osName,
                language: languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage.toLocaleUpperCase()
            };
            if (pushToken) {
                await httpClient.post(`${services.notification_ms}/devices`, deviceInfo, {
                    headers: {
                        'Accept-Language': deviceInfo.language
                    }
                });
            }
        } catch (err) {}
    };
    useEffect(()=>{
        hasSentDeviceInfo();
    }, []);
    const isSomeApps = [
        'bank-plus',
        'invest',
        'b2b-real-env'
    ].some((t)=>location.pathname.includes(t));
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Flex, {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            h: "100vh",
            w: "100vw",
            children: /*#__PURE__*/ _jsx(LogoIcon, {})
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !isSomeApps && /*#__PURE__*/ _jsx(_Fragment, {
                children: isLargerThanMd ? /*#__PURE__*/ _jsx(Sidebar, {
                    isLargerThanMd: true
                }) : /*#__PURE__*/ _jsxs(Drawer, {
                    isOpen: isOpen,
                    onClose: onClose,
                    placement: "right",
                    children: [
                        /*#__PURE__*/ _jsx(DrawerOverlay, {}),
                        /*#__PURE__*/ _jsx(Responsive, {
                            onClose: onClose,
                            onToggle: onToggle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
                paddingLeft: {
                    lg: !isSomeApps ? '272px' : 0
                },
                children: [
                    /*#__PURE__*/ _jsx(ConditionalContainer, {
                        condition: isSomeApps,
                        boxProps: {
                            bg: mode('#F0F0F0', '#0A0B0D')({
                                colorMode
                            })
                        },
                        containerProps: {
                            px: {
                                base: 0,
                                md: 4,
                                lg: 2,
                                xl: 0
                            }
                        },
                        children: /*#__PURE__*/ _jsx(Header, {
                            isLargerThanMd: isLargerThanMd,
                            onSidebarOpen: onToggle,
                            isSidebarOpen: isOpen,
                            isSomeApps: isSomeApps
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Main, {
                        boxProps: {
                            p: isSomeApps ? 0 : {
                                md: '0 48px 64px',
                                base: '0 16px 64px'
                            }
                        },
                        children: [
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.status) === 'rejected' || (permissions === null || permissions === void 0 ? void 0 : permissions.status) === 'rejected' || (processClaims === null || processClaims === void 0 ? void 0 : processClaims.status) === 'rejected' ? /*#__PURE__*/ _jsx(ConditionalContainer, {
                                condition: isSomeApps,
                                containerProps: {
                                    px: {
                                        base: 0,
                                        md: 4,
                                        lg: 2,
                                        xl: 0
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(ErrorAlert, {})
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    children,
                                    /*#__PURE__*/ _jsx(Survey, {}),
                                    /*#__PURE__*/ _jsx(CampaignNextModal, {}),
                                    /*#__PURE__*/ _jsx(FatcaAlert, {}),
                                    /*#__PURE__*/ _jsx(Box, {
                                        position: "fixed",
                                        right: 5,
                                        bottom: "80px",
                                        zIndex: 111,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 5,
                                        alignItems: "flex-end",
                                        children: /*#__PURE__*/ _jsx(VideoTutorial, {})
                                    }),
                                    /*#__PURE__*/ _jsx(TradePlatformModal, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsx(NotificationProvider, {})
                        ]
                    })
                ]
            })
        ]
    });
};
